import { dealsDuckCreator } from 'axl-ducks';
import { WalletStorageService } from 'wallet-manager';
import { PaymentCalculationFetcher } from '@syndicated-wallet/helpers/fetchers';

const dealsDuck = dealsDuckCreator({
    store: 'deals',
    paymentFetcher: PaymentCalculationFetcher,
    walletStorageService: new WalletStorageService({
        environment: process.env.ENVIRONMENT,
    }),
});

export default dealsDuck;
